// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__QitVN","logo":"Login_logo__W+opJ","header":"Login_header__OKMan","button":"Login_button__urnCv","icon":"Login_icon__mJKZf"};